import { useFeatureFlags } from "../contexts/FeatureFlagContext";

export function maskPatientName(name?: string | null): string {
  if (!name || !name.trim()) return "";
  const firstName = name.trim().toUpperCase().split(/\s+/)[0];
  const prefix = firstName.slice(0, 2);
  const maskLength = Math.min(Math.max(firstName.length - 2, 0), 4);
  return prefix + "*".repeat(maskLength);
}

export const useMaskPatientName = () => {
  const { mask_patient_name_tv } = useFeatureFlags();
  return (name?: string | null) =>
    mask_patient_name_tv ? maskPatientName(name) : name ?? "";
};
